import { useState } from 'react'
import Slider from 'react-slick'
import Image from 'next/image'
import { Typography } from '@healingpaper/cell'

import { getResizedImageUrl, ResizableImageFormats } from '@/utils/image-resizer/imageResizer'

interface Props {
  country?: string
  photos: string[]
  name: string
}

const PhotoSlide: React.FC<Props> = ({ name, photos }) => {
  const [slideIndex, setSlideIndex] = useState(0)
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (index: number) => setSlideIndex(index),
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        aspectRatio: '5/2',
      }}
    >
      {photos.length > 1 ? (
        <Slider {...settings}>
          {photos.map((url, index: number) => (
            <div key={url + index} className="w-full aspect-[5/2] overflow-hidden">
              <Image
                src={getResizedImageUrl(url, { format: ResizableImageFormats.WEBP })}
                alt={`${name}_${index}_image`}
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
                priority={index === 0}
                width={600}
                height={240}
              />
            </div>
          ))}
        </Slider>
      ) : (
        <div className="w-full aspect-[5/2] overflow-hidden">
          <Image
            priority
            src={getResizedImageUrl(photos[0], { format: ResizableImageFormats.WEBP })}
            alt={`${name}_0_image`}
            sizes="100vw"
            style={{
              width: '100%',
              height: 'auto',
            }}
            width={600}
            height={240}
          />
        </div>
      )}
      <div className="absolute right-3 bottom-3 rounded-full bg-black bg-opacity-60 px-3 py-1 flex items-center">
        <Typography type="caption1" color="white">
          {slideIndex + 1} / {photos.length}
        </Typography>
      </div>
    </div>
  )
}

export default PhotoSlide
